import { render, staticRenderFns } from "./cModalProveedor.vue?vue&type=template&id=93d89cda"
import script from "./cModalProveedor.vue?vue&type=script&lang=js"
export * from "./cModalProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports